<!--
 * @Author: guoyu
 * @Date: 2020-09-14 10:16:51
 * @LastEditors: zheng zheng@sence.sg
 * @LastEditTime: 2022-11-28 15:22:27
 * @Description: 评论信息
-->
<template>
  <div class="comment-list">
    <div class="detail-title">
      <span
        >評分及評價<span v-show="commentTotal">
          ({{ commentTotal }})</span
        ></span
      >
      <div class="star-count">
        <span>{{ (skillInfo.starRating || '') | parseNum(1) }}</span>
        <fps-star :count="skillInfo.starRating" :size="15" />
      </div>
    </div>
    <div v-if="commentCateList && commentCateList.length" class="comment-cate">
      <div
        v-for="c in commentCateList"
        :key="`comment-cate-${c.id}`"
        class="one-comment-cate"
      >
        {{ c.tag }}<span class="count">({{ c.count }})</span>
      </div>
    </div>
    <div v-if="commentList.length" class="comment-list-wrap">
      <div
        v-for="(c, i) in commentList"
        :key="'comment-' + i"
        class="one-comment"
      >
        <BorderAvatar
          class="comment-avatar"
          :borderMethod="borderMethod(c.giftRankOrder)"
          :style="{ transform: `scale(${commentRate(c.giftRankOrder)})` }"
        >
          <fps-avatar
            :class="!c.anonymous && 'pointer'"
            :src="c.commentatorAvatarUrl"
            :dressup="c.avatarFrame"
            :level="borderMethod(c.giftRankOrder) ? 0 : c.commentatorUserLevel"
            @click.native="!c.anonymous && openMasterDetail(c.commentatorUuid)"
          />
        </BorderAvatar>
        <div class="info-wrap">
          <div
            class="nickname pointer"
            @click="openMasterDetail(c.commentatorUuid)"
          >
            {{ c.commentatorName }}
            <span
              class="userlevel-tag level-mg"
              :class="`level-${c.commentatorUserLevel}`"
            ></span>
            <fps-icon
              v-if="c.commentatorUuid == adminUuid"
              type="v-mark"
              class="icon"
              size="18"
              color="#FFA24E"
            />
          </div>
          <div class="comment-time">
            {{ new Date(c.createTime).$format('yyyy-MM-dd') }}
          </div>
          <div class="comment-content">
            <img
              v-if="c.recommendStatus === 'Recommend'"
              class="good-comment"
              src="~@/assets/image/icons/comment-good.png"
            />
            {{ c.content }}
          </div>
          <div v-if="c.tags && c.tags.length" class="tags-list-wrap">
            <fps-icon type="tag" size="10" />
            {{ c.tags.map(tag => tag.tag).join('，') }}
          </div>
          <div
            v-if="isSelf && c.reply.status === 'CanReply'"
            class="reply-btn"
            @click="editReply(i)"
          >
            <fps-icon type="reply" size="10" />
            回覆
          </div>
          <div
            v-if="isSelf && c.reply.status === 'CanReply' && replyIndex === i"
            class="replying-wrap"
          >
            <div class="master-reply">
              <span class="nickname">{{ playerInfo.nickname }}</span>
              <span>回覆：</span>
            </div>
            <textarea
              v-model="c.replyContent"
              class="reply-content"
              placeholder="請輸入回覆內容"
            />
            <div class="reply-btns">
              <button class="cancel-btn" @click="cancelReply">取消</button>
              <button
                class="confirm-btn"
                :disabled="!c.replyContent"
                @click="finshReply"
              >
                <i v-if="c.replyLoading" class="el-icon-loading"></i>
                <span v-else>完成</span>
              </button>
            </div>
          </div>
          <div
            v-if="c.reply.status == 'HadReply' && c.reply.content"
            class="replying-wrap"
          >
            <div class="master-reply">
              <span class="nickname">{{ playerInfo.nickname }}</span>
              <span>回覆：</span>
            </div>
            <div class="replyed-content">{{ c.reply.content }}</div>
          </div>
        </div>
        <fps-star class="comment-star" :count="c.starRating" :size="10" />
      </div>
      <div v-if="commentFinshed" class="no-more-comment">沒有更多了</div>
      <div v-else-if="gettingComment" class="get-more-comment">
        <i class="el-icon-loading"></i>
      </div>
      <div v-else class="get-more-comment pointer" @click="getNormalList">
        <span>查看更多</span>
      </div>
    </div>
    <div v-else-if="!gettingComment" class="comment-empty">
      <img
        class="comment-empty-img"
        src="~@/assets/image/background/empty-comment.png"
      />
      <span class="comment-empty-text">目前還沒有任何評價喔～</span>
    </div>
  </div>
</template>
<script>
// import CommentItem from '@/components/CommentItem/index';
import { mapGetters } from 'vuex';
import { getCommentList } from '@/api/app';
import BorderAvatar from '@/components/FpsAvatar/border-avatar';
export default {
  components: {
    BorderAvatar
  },
  props: {
    skillInfo: {
      type: Object,
      default: () => {
        return {};
      }
    },
    playerInfo: {
      type: Object,
      default: () => {
        return {};
      }
    },
    isSelf: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      topList: [], // 置顶评论
      normalList: [], // 其它评论
      loadingTop: true,
      playerUserUuid: this.$route.params.uuid,
      lastItemId: null,
      commentCateList: [],
      gettingComment: false,
      showMore: false,
      total: 0,
      replyIndex: -1 // 當前回覆的評論
    };
  },
  computed: {
    ...mapGetters(['adminUuid']),
    commentList() {
      let newList = this.topList.concat(this.normalList);
      if (!this.showMore && newList.length > 2) return newList.slice(0, 2);
      return newList;
    },
    commentTotal() {
      return this.skillInfo.countComment || 0;
    },
    commentFinshed() {
      return this.commentList.length >= this.total;
    }
  },
  methods: {
    commentRate(rank) {
      switch (rank) {
        case -1:
          return this.$store.state.app.avatarBorder.guardOneCommentRate;
        default:
          return 1;
      }
    },
    borderMethod(d) {
      if (d === 0) {
        return 3 + (this.playerInfo.strongest.guardLevel || 1);
      } else if (d === -1) {
        return 3;
      } else if (d) {
        return 2;
      } else {
        return 0;
      }
    },
    getTopComment() {
      this.gettingComment = true;
      return getCommentList({
        topComment: true,
        playerUserUuid: this.playerUserUuid,
        playerSkillId: this.skillInfo.id,
        offset: 6
      })
        .then(({ data }) => {
          this.gettingComment = false;
          this.commentCateList = data.tagStatic;
          this.total = data.totalRemain;
          if (data && Array.isArray(data.pageContent)) {
            this.topList = data.pageContent;
          }
          this.loadingTop = false;
        })
        .catch(() => {
          this.gettingComment = false;
        });
    },
    /**
     * @description: 獲取一般評論
     * @param {type} resolve 通知list組件數據到達
     */
    getNormalList(resolve, reject) {
      this.gettingComment = true;
      this.showMore = true;
      let offset = 10;
      return getCommentList({
        lastItemId: this.lastItemId,
        offset,
        playerUserUuid: this.playerUserUuid,
        playerSkillId: this.skillInfo.id
      })
        .then(({ data }) => {
          this.gettingComment = false;
          if (data && Array.isArray(data.pageContent)) {
            this.lastItemId = data.pageContent[data.pageContent.length - 1].id;
            const list = data.pageContent.filter(c => {
              return !~this.topList.findIndex(qC => qC.id === c.id);
            });
            this.normalList.push(...list);
            if (!list.length && data.pageContent.length === offset) {
              this.getNormalList(resolve, reject);
              return;
            }
            // 數據處理完成
            if (resolve) resolve(true);
          }
        })
        .catch(e => {
          this.gettingComment = false;
          if (reject) reject(e);
        });
    },
    editReply(index) {
      this.replyIndex = index;
    },
    cancelReply() {
      this.replyIndex = -1;
    },
    finshReply() {
      if (this.replyIndex === -1) return;
      const lastComment = this.commentList[this.replyIndex];
      lastComment.replyLoading = true;
      this.$http
        .post('/comment/player/writeReply', {
          orderCommentId: lastComment.reply.orderCommentId,
          content: lastComment.replyContent
        })
        .then(() => {
          this.cancelReply();
          lastComment.replyLoading = false;
          lastComment.reply.content = lastComment.replyContent;
          lastComment.reply.status = 'HadReply';
          lastComment.createTime = Date.now();
        })
        .catch(({ msg }) => {
          lastComment.replyLoading = false;
          this.$message.error(msg);
        });
    }
  },
  created() {
    this.getTopComment();
  }
};
</script>
<style lang="scss" scoped>
.comment-list {
  padding: 0 16px 32px;
  .detail-title {
    @include flex(space-between);
    font-weight: 500;
    font-size: 17px;
    color: #8c94aa;
    .star-count {
      @include flex;
      span {
        font-weight: 500;
        font-size: 16px;
        line-height: 22px;
        color: $color-gray-2;
        margin-right: 8px;
      }
    }
  }
  .comment-cate {
    @include flex(flex-start, flex-start);
    flex-wrap: wrap;
    margin-top: 6px;
    .one-comment-cate {
      margin: 8px 8px 0 0;
      padding: 4px 8px;
      border: 1px solid rgba(140, 148, 170, 0.3);
      border-radius: 50px;
      font-size: 15px;
      line-height: 24px;
      color: #222c43;
      cursor: default;
      @include flex;
      span {
        margin-left: 6px;
      }
      &.selected {
        border-color: $color-link;
        background: rgba(0, 122, 255, 0.1);
        color: $color-link;
      }
    }
  }
  &-wrap {
    display: flex;
    flex-direction: column;
    margin-top: 12px;
    .one-comment {
      margin-top: 12px;
      padding: 16px 0;
      @include flex(flex-start, flex-start);
      position: relative;
      $comment-first: 50px;
      .comment-star {
        position: absolute;
        top: $comment-first / 2;
        right: 0;
        transform: translateY(-50%);
      }
      .comment-avatar {
        width: $comment-first;
        height: $comment-first;
        margin-right: 20px;
      }
      .info-wrap {
        @include flex(flex-start, flex-start, column);
        flex: 1;
        .nickname {
          @include flex(flex-start);
          font-weight: 500;
          font-size: 15px;
          line-height: 20px;
          color: $color-gray-1;
          .icon {
            margin-left: 3px;
          }
        }
        .comment-time {
          font-weight: 500;
          font-size: 13px;
          line-height: 16px;
          color: rgba(99, 109, 134, 0.5);
          margin-top: 2px;
        }
        .comment-content {
          position: relative;
          width: 100%;
          margin-top: 16px;
          font-size: 15px;
          line-height: 22px;
          color: #222c43;
          word-break: break-all;
          .good-comment {
            position: absolute;
            width: 30px;
            right: 0;
            top: -20px;
          }
        }
        .tags-list-wrap {
          @include flex;
          margin-top: 8px;
          padding: 3.5px 8px;
          background: $color-button;
          border-radius: 50px;
          font-size: 12px;
          line-height: 17px;
          letter-spacing: -0.000319808px;
          color: $color-gray-3;
        }
        .reply-btn {
          margin-top: 8px;
          align-self: flex-end;
          font-size: 12px;
          line-height: 16px;
          color: $color-gray-1;
          @include flex;
          cursor: pointer;
          & > i {
            margin-right: 5px;
          }
        }
        .replying-wrap {
          margin-top: 16px;
          background: rgba($color: $color-gray-3, $alpha: 0.1);
          border-radius: 4px;
          padding: 16px;
          width: 100%;
          @include flex(flex-start, flex-start, column);
          .master-reply {
            @include flex;
            font-weight: 500;
            font-size: 14px;
            line-height: 20px;
            color: $color-gray-2;
            .nickname {
              margin-right: 4px;
              color: $color-gray-1;
            }
          }
          .replyed-content {
            margin-top: 4px;
            font-size: 14px;
            line-height: 22px;
            color: $color-gray-2;
            word-break: break-word;
          }
          .reply-content {
            margin-top: 8px;
            background: #ffffff;
            border: 1px solid $color-split;
            border-radius: 4px;
            padding: 12px 20px 0 12px;
            font-size: 14px;
            line-height: 22px;
            color: $color-gray-2;
            width: 100%;
            height: 90px;
            resize: none;
          }
          .reply-btns {
            align-self: flex-end;
            margin-top: 8px;
            @include flex;
            button {
              font-weight: 500;
              font-size: 14px;
              line-height: 20px;
            }
            .cancel-btn {
              color: $color-gray-3;
            }
            .confirm-btn {
              color: $color-link;
              margin-left: 16px;
              &:disabled {
                background: transparent !important;
                opacity: 0.3;
                color: $color-link !important;
              }
            }
          }
        }
      }
    }
    .no-more-comment,
    .get-more-comment {
      margin: 24px auto 0;
      width: 116px;
      height: 36px;
      @include flex;
      text-align: center;
      border-radius: 50px;
      font-size: 14px;
      line-height: 20px;
      letter-spacing: -0.000319808px;
      color: $color-gray-2;
    }
    .no-more-comment {
      color: $color-gray-3;
    }
    .get-more-comment {
      border: 1px solid $color-split;
    }
  }
  .comment-empty {
    @include flex(flex-start, center, column);
    margin-top: 34px;
    &-img {
      width: 140px;
    }
    &-text {
      margin-top: 15px;
      font-size: 14px;
      line-height: 20px;
      color: $color-gray-2;
    }
  }
}
.comment-list-wrap {
  padding: 0 8px;
}
.level-mg {
  margin-left: 2px;
}
</style>
